import React from "react";
import "./Services.css";
import ServiceItems from "./ServicesItems/ServiceItems";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Services() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="services reveal" id="services">
      <h1>Services</h1>
      <p className="services-description">
        Full-cycle development support from first prototype to enterprise scale.
        We choose the right tools for each project — not the other way around.
      </p>
      <ServiceItems />
    </div>
  );
}
